module.exports = __webpack_public_path__ + "img/tu14.359c38da.png";